let interval = setInterval(function() {
  if (window.zrl_mi) {
    clearInterval(interval);

    // Function to setup receipt upload click handler
    function setupReceiptUpload() {
      let element = document.getElementById('zrl-upload-receipt');
      if (element && !element.hasAttribute('data-zrl-initialized')) {
        element.setAttribute('data-zrl-initialized', 'true');
        
        // Add the click event listener
        element.addEventListener('click', function() {
          zrl_mi.show_dashboard('show_submit_a_receipt');
        });
        
        return true; // Element found and initialized
      }
      return false; // Element not found
    }
    
    // Try to setup immediately in case element already exists
    if (!setupReceiptUpload()) {
      // Setup a MutationObserver to check when the 'zrl-upload-receipt' element is added to the DOM
      let receiptObserver = new MutationObserver((mutationsList, receiptObserver) => {
        if (setupReceiptUpload()) {
          receiptObserver.disconnect();
        }
      });

      // Start observing the document with the configured parameters
      receiptObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Setup a MutationObserver to check when the 'b-zrl-dashboard' attribute is added to the DOM
    let dashboardObserver = new MutationObserver((mutationsList, dashboardObserver) => {
      // Get all elements with 'b-zrl-dashboard' attribute
      let elements = document.querySelectorAll('[b-zrl-dashboard]');

      for (let element of elements) {
        // If the element does not have the event listener, add it
        if (!element.hasAttribute('data-clicked')) {
          element.setAttribute('data-clicked', '');

          // Add the click event listener
          element.addEventListener('click', function() {
            zrl_mi.show_dashboard();
          });
        }
      }
    });

    // Start observing the document with the configured parameters
    dashboardObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['b-zrl-dashboard'] });
  }
}, 500);
